import React,{useState}  from 'react'
import {Box,Typography,Container,Button, Divider} from '@mui/material'

const BoxData = ({title,children})=>{
	return(
		<Box sx={{width:{md:"23%",xs:"100%"},height:100,mb:2,borderRadius:2,justifyContent:"flex-start",alignItems:"flex-start",backgroundColor:"#100f0f"}}>
			<Typography sx={{fontSize:12,fontFamily:"dinofans",height:"50%",p:1}}>
				{title}
			</Typography>
			<Box display="flex" flexDirection="row" height="50%"  justifyContent="space-between" alignItems="flex-end" sx={{backgroundColor:"#100101",borderBottomRightRadius:2,borderBottomLeftRadius:2}}>
				{children}
			</Box>
		</Box>
	)
}

export default BoxData